export enum EnumSalesTaskStatus {
  New = 13,
  Blocked = 14,
  InProgress = 15,
  InReview = 16,
  Closed = 17,
}
